import React from "react";
import PropTypes from "prop-types";

import {
  CheckboxController,
  DropdownController,
  EmailController,
  InputController,
  PermissionTooltip,
} from "./components";

export function UserForm({ initial }) {
  const { firstName, lastName, email, userRole, inviteNow } = initial;
  return (
    <React.Fragment>
      <InputController
        fluid
        name="firstName"
        label="First Name"
        defaultValue={firstName}
      />
      <InputController
        fluid
        name="lastName"
        label="Last Name"
        defaultValue={lastName}
      />
      <EmailController fluid name="email" label="Email" defaultValue={email} />
      <DropdownController
        defaultValue={userRole}
        label={
          <span>
            Permissions <PermissionTooltip roleTitle="Administrator" />
          </span>
        }
        name="userRole"
      />
      <CheckboxController
        label="Invite Now"
        name="inviteNow"
        defaultValue={inviteNow}
      />
    </React.Fragment>
  );
}

UserForm.propTypes = {
  initial: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    userRole: PropTypes.string,
    inviteNow: PropTypes.bool,
  }),
};

UserForm.defaultProps = {
  initial: {
    firstName: "",
    lastName: "",
    email: "",
    userRole: "",
    inviteNow: true,
  },
};

export default UserForm;
